import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { ConvertToken, CurrentConvertInfo } from './reducer'
import { PRIMARY_CURRENCY } from 'constants/currencies'
import { IConvertToken } from 'api/v1/market'

export function useConvertBaseToken() {
  return useSelector<RootState, ConvertToken>(
    (state) => state.convert.baseToken,
  )
}
export function useConvertQuoteToken() {
  return useSelector<RootState, ConvertToken>(
    (state) => state.convert.quoteToken,
  )
}

export function useCurrentConvertInfo() {
  return useSelector<RootState, CurrentConvertInfo>(
    (state) => state.convert.currentConvertInfo,
  )
}
export function useConvertTokenConfig() {
  return useSelector<RootState, IConvertToken[]>(
    (state) => state.market.trades.convertTokens,
  )
}

export function useConvertDisabled() {
  return useSelector<RootState, boolean>((state) => state.convert.swapDisabled)
}

export interface FastConvert {
  tokenId: number
  icon: string
  baseName: string
  quoteName: string
}
export function useFastConvertSymbols() {
  const _supportConvertToken = useConvertTokenConfig()
  const _list: FastConvert[] = []
  _supportConvertToken.forEach((token) => {
    if (token.name !== PRIMARY_CURRENCY) {
      _list.push({
        tokenId: token.id,
        icon: token.iconUrl,
        baseName: token.name,
        quoteName: PRIMARY_CURRENCY,
      })
    }
  })
  return _list
}
